export const timelineData = [
  {
    year: "Q1 2025",
    title: "The Skill Intelligence Vision",
    desc:
      "Launched CodeMatrix to solve the global 'Credential Inflation' crisis through high-fidelity engineering simulations.",
    title2: "Core DNA Framework",
    desc2:
      "Established the first-of-its-kind Behavioral Pattern Recognition engine to track real-time logic and problem-solving."
  },
  {
    year: "Q2 2025",
    title: "Enterprise Ecosystem Expansion",
    desc:
      "Launched CodeMatrix to redefine technical skill evaluation through real-world engineering simulations.",
    title2: "Integrity Guard Integration",
    desc2:
      "Released Process-Based Proctoring to eliminate AI-assisted plagiarism and verify 100% authentic human intelligence."
  },
  {
    year: "2026 Vision",
    title: "The Standard for Technical Truth",
    desc:
      "Scaling the Skill Intelligence Engine to become the global benchmark for Day-1 Ready engineering talent.",
    title2: "Precision Hiring Era",
    desc2:
      "Empowering the HR community with data-driven 'Job Position Fit' analytics and zero-risk talent shortlisting."
  }
];